export interface FeatureExtractionEligibilityInput {
  isFeatureFlagEnabled: boolean;
  projectId: string | undefined;
  visiblePointCloudCount: number;
  /** The active point cloud has a derived CRS URN to author in. */
  hasAuthoringCrs: boolean;
}

export function isFeatureExtractionEditingEligible(
  input: FeatureExtractionEligibilityInput
): boolean {
  return (
    input.isFeatureFlagEnabled &&
    input.projectId !== undefined &&
    input.visiblePointCloudCount > 0 &&
    input.hasAuthoringCrs
  );
}

export function isFeatureExtractionPaneEligible(
  editingEligible: boolean,
  viewModeType: string | undefined
): boolean {
  return editingEligible && viewModeType === '3D';
}
